import React from 'react';
import styled from 'styled-components';

type CheckboxProps = {
  name: string;
  label: string;
  errorMessage?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  'aria-label'?: string;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 480px) {
    align-items: flex-start;
  }
`;

const Input = styled.input`
  margin-right: 8px;
`;

const Label = styled.label`
  display: block;
  align-items: center;
  font-size: 14px;
  color: #636769;
  font-weight: normal;
`;

const ErrorMessage = styled.div`
  color: rgb(255, 117, 114);
  font-size: 12px;
  margin-top: 4px;
`;

export const Checkbox: React.FC<CheckboxProps> = (props) => {
  return (
    <Container>
      <Wrapper>
        <Input
          type="checkbox"
          name={props.name}
          id={props.name}
          checked={props.checked}
          onChange={(e) => props.onChange(e.target.checked)}
          aria-label={props['aria-label']}
        />
        <Label dangerouslySetInnerHTML={{ __html: props.label }} htmlFor={props.name} />
      </Wrapper>
      {props.errorMessage && <ErrorMessage>{props.errorMessage}</ErrorMessage>}
    </Container>
  );
};
